export default "__VITE_ASSET__CgKIyfOn__"